import React from "react";
import {
    FaFacebookSquare,
    FaInstagramSquare,
    FaLinkedin,
    FaPaperPlane,
} from "react-icons/fa";
import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";

const Contact = () => {
    const sendEmail = (e) => {
        e.preventDefault();
        const name = e.target.name.value;

        emailjs
            .sendForm(
                process.env.REACT_APP_SERVICE_ID,
                process.env.REACT_APP_TEMPLATE_ID,
                e.target,
                process.env.REACT_APP_PUBLIC_KEY
            )
            .then(
                (result) => {
                    if (result.status === 200) {
                        e.target.reset();
                        toast.success(`Hi, ${name}. Your message is sent`);
                    }
                },
                (error) => {
                    toast.error("Something went wrong! Please Try Again.");
                }
            );
    };

    return (
        <div id="contact" className="my-20">
            <div className="p-5">
                <h1 className="font-semibold opacity-30 text-yellow-100 text-4xl md:text-5xl text-center mt-2 mb-4">
                    MY CONTACT
                </h1>
                <div
                    className="grid gap-16 grid-cols-1 lg:grid-cols-2 justify-center items-start my-10"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                >
                    <div className="overflow-x-auto">
                        <table className="table w-full">
                            <tbody className="">
                                <tr className="hover border-2 border-yellow-50 border-opacity-10">
                                    <th className="border-2 border-yellow-50 border-opacity-10 text-orange-400">
                                        Address :
                                    </th>
                                    <td className="text-yellow-50">
                                        Dhaka, Bangladesh
                                    </td>
                                </tr>

                                <tr className="hover border-2 border-yellow-50 border-opacity-10">
                                    <th className="border-2 border-yellow-50 border-opacity-10 text-orange-400">
                                        Phone :
                                    </th>
                                    <td className="text-yellow-50">
                                        +8801733772851
                                    </td>
                                </tr>

                                <tr className="hover border-2 border-yellow-50 border-opacity-10">
                                    <th className="border-2 border-yellow-50 border-opacity-10 text-orange-400">
                                        Email :
                                    </th>
                                    <td className="text-yellow-50">
                                        gourobsaha008@gmail.com
                                    </td>
                                </tr>
                                <tr className="hover border-2 border-yellow-50 border-opacity-10">
                                    <th className="border-2 border-yellow-50 border-opacity-10 text-orange-400">
                                        Social :
                                    </th>
                                    <td className="text-yellow-50 flex gap-4 text-2xl">
                                        <a
                                            href="https://www.linkedin.com/in/gourob-saha-surjo-632751200/"
                                            target="_blank"
                                            className="transition font-semibold ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:text-orange-400 duration-300"
                                            rel="noopener noreferrer"
                                        >
                                            {" "}
                                            <FaLinkedin />
                                        </a>
                                        <a
                                            href="https://www.facebook.com/surjo.saha.547/"
                                            target="_blank"
                                            className="transition font-semibold ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:text-orange-400 duration-300"
                                            rel="noopener noreferrer"
                                        >
                                            {" "}
                                            <FaFacebookSquare />
                                        </a>
                                        <a
                                            href="https://www.instagram.com/gourob_saha/"
                                            target="_blank"
                                            className="transition font-semibold ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:text-orange-400 duration-300"
                                            rel="noopener noreferrer"
                                        >
                                            {" "}
                                            <FaInstagramSquare />
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <form onSubmit={sendEmail}>
                            <div className="flex flex-col gap-2">
                                <div className="mb-6 w-full">
                                    <input
                                        type="text"
                                        name="name"
                                        className=" text-sm rounded-lg focus:ring-secondary focus:border-secondary block w-full p-2.5"
                                        placeholder="Your Name"
                                        required
                                    />
                                </div>
                                <div className="mb-6 w-full">
                                    <input
                                        type="user_email"
                                        name="email"
                                        className=" text-sm rounded-lg focus:ring-secondary focus:border-secondary block w-full p-2.5"
                                        placeholder="Your Email"
                                        required
                                    />
                                </div>
                            </div>
                            <div>
                                <textarea
                                    rows="4"
                                    name="message"
                                    className="p-2.5 w-full text-sm rounded-lg focus:ring-secondary"
                                    placeholder="Your Message"
                                ></textarea>
                            </div>

                            <div className="flex justify-center mt-2">
                                <button className="btn-brand-primary">
                                    Send Message{" "}
                                    <FaPaperPlane className="ml-2" />
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
